import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding-top: 5vw;
    padding-bottom: 10vw;
    min-height: 85vh;
    background-color: ${Colors.commons.gray};
`;

export const BadgeList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    margin-bottom: 12vw;
    gap: 2vw;
`;

export const Footer = styled.div`
    position: fixed;
    bottom: 0;
    background-color: ${Colors.primary[100]};
    padding: 3vw;
    width: 100%;
    text-align: center;
`;

export const FooterText = styled.span`
    font-size: 10vw;
    color: ${Colors.commons.white};
`;

export const BoldText = styled.span`
    font-weight: bold;
    color: ${Colors.commons.white};
`;

export const ScheduleText = styled.p`
    font-size: 8vw;
    color: ${Colors.primary[100]};
    margin-top: 0;
    margin-bottom: 0.5rem;
`;

export const ScheduledWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 0.5rem;
    border-bottom: 4px solid ${Colors.commons.grayFading};
    margin-bottom: 0.5rem;
`;
